import * as React from "react";
import { OrderMachineContext } from "components/Orders/state/orderMachine";
import ReviewForm from "../ReviewForm";

interface ReviewPanelContainerProps {
  mapRef: React.RefObject<mapboxgl.Map>;
}

export default function ReviewPanelContainer(props: ReviewPanelContainerProps) {
  const timezone = OrderMachineContext.useSelector(
    (state) => state.context.timezone
  );

  if (timezone === null) {
    return null;
  }

  return <ReviewForm mapRef={props.mapRef} />;
}
